import React, { useState } from 'react';

const CgvAuth = ({ onAuthSuccess }) => {
    const [loginData, setLoginData] = useState({ username: '', password: '' });
    const [loginError, setLoginError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const username = loginData.username;
    const password = loginData.password;

    const handleLogin = async (event) => {
        event.preventDefault();
        try {
            const token = window.btoa(`${username}:${password}`)
            setIsLoading(true);
            setLoginError('');
            const response = await fetch(`${process.env.REACT_APP_SERVER_URI}/api/cgv/login`, {
                method: "POST",
                headers: { 'Authorization' : `${token}`},
            });

            if (!response.ok) {
                throw new Error('Nom d\'utilisateur ou mot de passe incorrect');
            }

            onAuthSuccess({ username, password });
            setIsLoading(false);

        } catch (err) {
            console.log(err)
            setLoginError(err.message);
            setIsLoading(false)
        }
    };

    return (
        <div className="cgv-manager">
            <header className="cgv-header">
                <h1>Gestionnaire CGV</h1>
                <p>Authentification requise</p>
            </header>

            <div className="cgv-login">
                <form onSubmit={handleLogin} className="login-form">
                    <h3>Connexion</h3>
                    
                    {loginError && (
                        <div className="login-error">
                            {loginError}
                        </div>
                    )}

                    <div className="input-group">
                        <label htmlFor="username">Nom d'utilisateur:</label>
                        <input
                            type="text"
                            id="username"
                            value={loginData.username}
                            onChange={(e) => setLoginData(prev => ({ ...prev, username: e.target.value }))}
                            required
                            disabled={isLoading}
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="password">Mot de passe:</label>
                        <input
                            type="password"
                            id="password"
                            value={loginData.password}
                            onChange={(e) => setLoginData(prev => ({ ...prev, password: e.target.value }))}
                            required
                            disabled={isLoading}
                        />
                    </div>

                    <button type="submit" className="login-btn" disabled={isLoading}>
                        {isLoading ? 'Connexion...' : 'Se connecter'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CgvAuth;
